import { faAngleDown, faAngleUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import { useState } from 'react';
import Container from '../atoms/Container';

/**
 * CardToggle is a collapsible container that can be minimised / maximised.
 *
 * @param {{
 *      title: React.ReactNode;
 *      border: 'green' | 'blue' | 'orange' | 'red';
 *      size: 'xl' | 'lg' | 'md' | 'sm';
 *      children: React.ReactNode;
 * }} props
 */
function CardToggle({ title, size, border, children }) {
    
    const [open, setOpen] = useState(false)

    return (
        <Container border={border}>
            <button
                type="button"
                onClick={() => setOpen(!open)}
                className={`flex w-full justify-between items-center font-bold p-6 border-b text-${size}`}
            >
                <span className="flex-1 text-left">{title}</span>
                <FontAwesomeIcon icon={open ? faAngleUp : faAngleDown} />
            </button>

            {open && children}
        </Container>
    )
}

CardToggle.propTypes = {
    title: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.node
    ]),
    border: PropTypes.oneOf(['green', 'blue', 'orange', 'red']),
    size: PropTypes.oneOf(['xl', 'lg', 'md', 'sm']),
    children: PropTypes.node.isRequired,
};

CardToggle.defaultProps = {
    title: '',
    border: undefined,
    size: 'xl',
};

export default CardToggle;
